export const ADMIN_AUTH_DATA = 'adminAuthData';
export const DEVICE_ID = 'deviceId';